/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { DisplayHtmlContent, Heading, toTitleCase } from 'sarsaparilla';

const headings = {
    'selecting-tree': 'Selecting Your Tree',
    'where-to-cut': 'Where to Cut Your Tree',
    'plan-trip': 'How to Plan your Trip',
    'cut-tips': 'Helpful Cutting tips',
};

export default function List({ content }) {
    return (
        <div className="ap-list">
            {content.map(({ title = '', paragraphs = [] }, i) => {
                const hasParagraphs = !!paragraphs?.length;

                return (
                    <div className="ap-list-item" key={i}>
                        {headings[title] ? (
                            <Heading
                                appearance="small"
                                headingLevel={3}
                                className="ap-list-title"
                            >
                                {toTitleCase(headings[title])}
                            </Heading>
                        ) : null}
                        {hasParagraphs && (
                            <div className="ap-list-content" key={i}>
                                <ul>
                                    {paragraphs.map((html, j) => {
                                        return (
                                            <li key={`${i}-${j}`}>
                                                <DisplayHtmlContent html={html} />
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

List.propTypes = {
    content: PropTypes.array,
};
